import { env, JS2Native } from '@utils';
import { orderRequest, getSkuGuide } from '@/api/order.js';
import Toast from '@/components/IToast';
import router from '@/router/index.js';
import { jumpTo } from '@/utils/common';

/**
 *
 * @param {string} sourceId     渠道id
 * @param {string} channel      来源(igc_from)
 * @param {string} payMethod    支付方式
 * @param {string} putUrl       地址
 * @param {string} uid          用户id
 * @param {string} infoId       课程id
 * @param {string} upSpecilId   上规格id
 * @param {string} downSpecilId 下规格id
 * @param {string} mainSkuId    skuid
 * @param {string} introductionStatus   下单环境： 0、默认；1、微信； 2、APP；
 * @param {string} spm                  不知道是干啥的
 * @param {string} introductionURl      转介绍介绍链接
 * @param {string} introductionUid      转介绍介绍人id
 * @param {string} phoneInfo            手机信息
 */
export const fastPayment = async ({ options, route, callback }) => {
  const { igc_from, itemid, sourceId, spm, instructor, relMainOrderId } = route.query;
  let params = {
    channel: igc_from,
    sourceId,
    payMethod: 1,
    infoId: itemid,
    spm,
    relMainOrderId,
    ...options
  };
  //  小程序训练营需要参数
  if (params.channel === 'miniProgram') {
    params.wechatAppletAppId = options.miniAppId;
  }

  if (instructor) {
    let spreadStr = '';
    for (let key in route.query) {
      spreadStr += `${key}=${route.query[key]}&`;
    }
    params.introductionUid = instructor;
    params.introductionURl = `${location.origin}/mall/course?${spreadStr}`;
  }

  params.phoneInfo = await getPhoneInfo();
  params.introductionStatus = introductionStatus();
  params.putUrl = `${location.href}&igc_os=${env.isIOS ? 'ios' : 'android'}`;

  let payEnv = 'h5';
  if (env.isApp) {
    payEnv = 'app';
  }
  if (env.isWeChat) {
    payEnv = 'wechat';
  }
  if (params.channel === 'miniProgram') {
    payEnv = 'miniProgram';
  }

  if (payEnv === 'h5') {
    params.shopPayType = 0;
  } else {
    if (payEnv === 'app') {
      params.shopPayType = 2;
    } else if (payEnv === 'miniProgram') {
      params.shopPayType = 3;
      // params.wechatOpenId = miniOpenId;
    } else {
      params.shopPayType = 1;
      // params.wechatOpenId = openId;
    }
  }

  orderRequest(params, { handleError: () => { } }).then(res => {
    paySuccess(res, { options, route, callback });
    callback && callback(res);
  }).catch(err => {
    paySuccess(err, { options, route, callback });
    callback && callback(err);
  });

};

function introductionStatus() {
  if (env.isWeChat) { return 1 }
  if (env.isApp) { return 2 }
  return 0;
}

async function getPhoneInfo() {
  let datas = {};
  if (env.isApp) {
    const { data } = await JS2Native({ name: 'getUserInfo' });
    datas = data;
  }
  return `${navigator.userAgent}@${datas['App-Device-Key']}@${datas['App-UserApp-Agent']}`;
}

function paySuccess(data, { options, route, callback }) {
  if (data.code === 10005) {
    const { mainSkuId, upSpecilId, downSpecilId, upspecilName, downspecilName, no_params, keysStr } = options;
    const { orderId, userId } = data.data;
    const { put_type, itemid } = route.query;

    getSkuGuide({ systemOrderId: orderId }).then(res => {
      const { type, guideContent, needRefund, clickType, jumpType } = res.data;
      const url = type === 4 && guideContent && !needRefund ? guideContent : '/mall/success';
      if (type === 4 && guideContent && !needRefund) {
        // location.href = `${url}?order_id=${orderId}&u_id=${userId}&itemid=${itemid}`;
        // @aigc:start
        if (clickType == 100) {
          jumpTo({ jumpType: jumpType, jumpUrl: guideContent, useRouter: false });
        } else {
          location.href = `${url}?order_id=${orderId}&u_id=${userId}&itemid=${itemid}`;
        }
        // @aigc:end
      } else {
        const query = {
          ...route.query,
          total: 0,
          order_id: orderId,
          u_id: userId,
          itemid: itemid,
        };
        // 有规格
        if (!no_params) {
          query.up_specil_id = upSpecilId;
          downSpecilId && (query.down_specil_id = downSpecilId);
          query.upspecilName = upspecilName;
          downspecilName && (query.downspecilName = downspecilName);
          query.skuid = mainSkuId;
          query.key = keysStr;
        }
        // put_type 不知道是干啥的
        if (put_type) {
          query.put_type = 1;
        }

        router.push({
          path: url,
          query
        });
      }
    });
  } else {
    data.msg && Toast(data.msg);
  }
}